import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CoachSideBar from "./Profile/CoachSideBar";
import Navbar from "../Navbar";
import SearchIcon from "@mui/icons-material/Search";
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import { servicefeature } from '../../styles/style'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LaunchIcon from '@mui/icons-material/Launch';
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import { getServiceById } from "../../actions/userAuth";
import { useDispatch } from "react-redux";


export default function ServicesStatus() {
  const [service, setService] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    dispatch(getServiceById({ id }, (data) => {
      setLoading(false);
      setService(data.data.data);
    }));
  }, [id]);
  return (
    <>
      <Layout>
        <UserLayout userRole={"coach"}>
          
        <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection:{md:'row', xs:'column'}, mt: 8, gap:{md:0, xs:2} }}>
                <Button sx={{ px: 5, py: 1 }} variant="outlined" onClick={() => navigate('/coach/services-status')} startIcon={<ArrowBackIosIcon />}>
                  Go Back
                </Button>
                <Box>
                  <Paper
                    component="form"
                    sx={{
                      p: "2px 4px",
                      display: "flex",
                      alignItems: "center",
                      width:{md:400, xs:'70%'},
                      bgcolor: "#F8FAFF",
                      boxShadow:
                        "0px 40.30877685546875px 80.6175537109375px -15.115790367126465px #3665D014",
                      border: "1.72px solid #cedefd",
                    }}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="Search"
                      inputProps={{ "aria-label": "search google maps" }}
                    />
                    <IconButton
                      type="button"
                      sx={{ p: "10px" }}
                      aria-label="search"
                    >
                      <SearchIcon />
                    </IconButton>
                  </Paper>
                </Box>
              </Box>
          {loading
            ?
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
              <CircularProgress size={24} />
            </Box>
            :
            <>

              <Paper sx={{
                border: '1.28px solid #D2D2D24D', boxShadow: '0px 40.996337890625px 81.99267578125px -15.373626708984375px #3665D014', my: 3
              }}>
                <Box p={3}>
                  <Typography sx={{
                    lineHeight: "3rem",
                    textAlign: "left",
                    mt: 2
                  }}
                    className="heading2bold">{service?.serviceName}</Typography>
                  {
                    service?.trainingName != ""
                      ?
                      ""
                      :
                      <Box>
                        <Typography sx={{
                          lineHeight: "4.25rem",
                          textAlign: "left",
                          mt: 1
                        }}
                          className="subHeading2Bold">Service Detail</Typography>
                        <ul style={{
                          lineHeight: "1.75rem",
                          textAlign: "left",
                        }}
                          className="text1Mid">
                          <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                          <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. </li>
                          <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                          <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. </li>
                        </ul>
                      </Box>
                  }
                  <Box>
                    <Typography sx={{
                      lineHeight: "4rem",
                      textAlign: "left",
                      mt: 1
                    }}
                      className="heading2bold">Service Detail by Coach</Typography>
                    <ul style={{
                      lineHeight: "1.75rem",
                      textAlign: "left",
                    }}
                      className="text1Mid">
                      <li style={{ paddingBottom: '20px' }}>{service?.descriptionByCoach}</li>
                      {
                        service?.keyFeatures != "" ?
                          <li style={{ paddingBottom: '20px', fontWeight: 700, }}>{service?.keyFeatures}</li>
                          :
                          ""
                      }
                    </ul>
                  </Box>
                  <Box>
                    <Box>
                      <Typography sx={{
                        lineHeight: "5rem",
                        textAlign: "left",
                        mt: 1
                      }}
                        className="heading2bold">Medium Available</Typography>
                      <Box display={{ display: 'flex', gap: 15 }}>
                        <Box sx={{ bgcolor: '#2544EE', color: '#fff', px: 3, py: 1, borderRadius: '30px' }}> <VideocamRoundedIcon /></Box>

                        <Box sx={{
                          fontFamily: 'Inter', bgcolor: '#F8FAFF', borderRadius: '40px', ml: 10, boxShadow: '0px 22.9827823638916px 45.9655647277832px -8.61854362487793px #3665D014', border: '1px solid #D2D2D299'
                        }}>
                          <Typography sx={{ px: 8, py: 1 }} className="text1Mid">Language: <span style={{ color: '#2544EE' }}> {service?.language}</span></Typography>
                        </Box>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', pt: 5, gap: 3, ml: 5 }}>
                      <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Number of Session : <span style={{ color: '#2544EE' }}> {service?.numberOfSessions}</span></Typography></Box>
                      <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Service Duration : <span style={{ color: '#2544EE' }}> {service?.totalDuration} </span></Typography></Box>
                      <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Duration/Session :<span style={{ color: '#2544EE' }}>  {service?.durationPerSession}  </span></Typography></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{
                  bgcolor: '#F8FAFF', border: '1px solid #D2D2D299', my: 5, boxShadow: '0px 22.98290252685547px 45.96580505371094px -8.6185884475708px #3665D014'
                }}>
                  <Typography sx={{
                    py: 3,
                    textAlign: "center",
                  }} className="heading2bold">Price: ₹{service?.enterPrice}/-</Typography>
                </Box>
                <Box sx={{ textAlign: 'center' }} >
                  <Button variant="contained" className="text1Mid" sx={{ px: 5, py: 2, bgcolor: '#2544EE', borderRadius: '30px', mb: 5 }}>Okay</Button>
                </Box>
              </Paper>
            </>}
        </UserLayout>
      </Layout>
    </>
  )
}
